import { type AnimationOptionFade } from "@package/ui-gql/index-data-access";
import { type CSSProperties, useMemo } from "react";
import { type AnimationComponentProps } from "./animated-card-interface";

export function AnimationCardFade({
  animation,
  nodeCurr,
  nodePrev,
  reversed,
}: AnimationComponentProps<AnimationOptionFade>) {
  const styleCardBack = useMemo<CSSProperties>(() => {
    let styles: CSSProperties = {
      opacity: 1,
      transition: `opacity ${animation.duration}s ease-in-out`,
    };

    if (reversed) {
      styles = {
        ...styles,
        opacity: 0,
      };
    }

    return styles;
  }, [animation.duration, reversed]);

  return (
    <div className="relative w-full h-full">
      <div className="absolute w-full h-full">{nodePrev}</div>
      <div className="absolute w-full h-full" style={styleCardBack}>
        {nodeCurr}
      </div>
    </div>
  );
}
